// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1nYqW","infoBtn":"quickbooks_infoBtn__1wo_9","formBox":"quickbooks_formBox__2d-4d","formFooter":"quickbooks_formFooter__1UA4Q"};